<template>
  <div id="dashboard-microareas">
    <div class="row">
      <div class="col-lg-12">
        <h2>
          <strong>Microáreas</strong> por classificação considerando o cadastro
          no e-SUS
        </h2>
        <hr />
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-lg-4">
        <donut-chart :series="dadosDashboard" nivel="3"></donut-chart>
      </div>
      <div class="col-lg-8">
        <tree-map
          nivel="3"
          :series="dadosDashboard"
          @openModal="openModal($event)"
        ></tree-map>
      </div>
      <b-modal
        id="dashboard-microareas-modal"
        v-model="modal.enabled"
        centered
        size="xl"
        hide-footer
      >
        <template #modal-title>
          {{ modal.title }}
          <span class="tag-indicador"> CVAT </span>
          <span v-if="periodo != null" class="tag-indicador">
            {{ periodo.label }}
          </span>
        </template>
        <v-app class="app-tabela">
          <div class="box mt-0 mb-5">
            <v-card class="tabela">
              <v-card-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar por nome da equipe, CNES, INE ou MA"
                  class="input-bottom"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                @pagination="getPagination"
                :page="currentPage"
                :footer-props="{
                  itemsPerPageText: '',
                  'items-per-page-options': [10],
                  'disable-items-per-page': true,
                }"
                :loading="modal.table.loading"
                loading-text="Carregando, Por favor espere"
                :headers="headers"
                :items="indexedItems"
                :item-class="getRowColor"
                :search="search"
                :single-expand="true"
                :expanded.sync="expanded"
                item-key="index"
                show-expand
                class="elevation-1"
                @item-expanded="onItemExpanded"
              >
                <template v-slot:[`footer.page-text`]="items">
                  <div class="info-table-item tabela-esus-pec">
                    <FonteEsusPecGlobal />
                  </div>
                  <span class="paginacao"
                    >{{ items.pageStart }} - {{ items.pageStop }} de
                    {{ items.itemsLength }} microáreas</span
                  >
                </template>

                <template v-slot:item.vinculo_acompanhamento="{ item }">
                  <progress-bar
                    :items="item.dados_vinculo_acompanhamento"
                  ></progress-bar>
                </template>

                <template v-slot:expanded-item="{ headers, item }">
                  <td colspan="6">
                    <div class="row">
                      <div class="col-lg-6">
                        <cidadaos-vinculados-chart
                          :series="expandedItem.vinculados.series"
                          nivel="3"
                        ></cidadaos-vinculados-chart>
                      </div>
                      <div class="col-lg-6">
                        <cidadaos-acompanhados-chart
                          :series="expandedItem.acompanhados.series"
                          nivel="3"
                        ></cidadaos-acompanhados-chart>
                      </div>
                    </div>
                  </td>
                </template>

                <template v-slot:progress>
                  <v-progress-linear
                    color="blue"
                    :height="10"
                    indeterminate
                  ></v-progress-linear>
                </template>
                <template v-slot:no-data>
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
                <template v-slot:no-results style="padding: 0px">
                  <div class="alert alert-info mb-0">
                    <b
                      >Nenhuma informação encontrada. Selecione outro filtro.</b
                    >
                  </div>
                </template>
              </v-data-table>
            </v-card>
          </div>
        </v-app>
      </b-modal>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import ProgressBar from './ProgressBar'
import DonutChart from './DonutChart.vue'
import TreeMap from './TreeMap.vue'
import CidadaosVinculadosChart from './CidadaosVinculadosChart.vue'
import CidadaosAcompanhadosChart from './CidadaosAcompanhadosChart.vue'

export default {
  components: {
    apexchart: VueApexCharts,
    ProgressBar,
    DonutChart,
    TreeMap,
    CidadaosVinculadosChart,
    CidadaosAcompanhadosChart,
  },
  props: {
    dadosDashboard: {
      type: Array,
      default: () => {},
    },
    dadosEscore: {
      type: Array,
      default: () => {},
    },
    periodo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'CNES',
          align: 'start',
          filterable: true,
          value: 'nu_cnes',
        },
        {
          text: 'Equipe',
          align: 'start',
          filterable: true,
          value: 'no_equipe',
        },
        {
          text: 'INE',
          align: 'start',
          filterable: true,
          value: 'ine',
          width: '150px',
        },
        {
          text: 'Microárea',
          align: 'start',
          filterable: true,
          value: 'micro_area',
        },
        {
          text: 'Vínculo e Acompanhamento',
          align: 'start',
          sortable: false,
          filterable: false,
          value: 'vinculo_acompanhamento',
        },
        { text: '', value: 'data-table-expand' },
      ],
      currentPage: 1,
      expanded: [],
      modal: {
        title: '',
        enabled: false,
        table: {
          loading: false,
          data: [],
        },
      },
      expandedItem: {
        vinculados: {
          series: [],
        },
        acompanhados: {
          series: [],
        },
      },
    }
  },
  computed: {
    indexedItems() {
      return this.modal.table.data.map((item, index) => {
        return {
          index: index,
          ...item,
        }
      })
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    onItemExpanded(item) {
      this.expandedItem.vinculados.series = [
        {
          data: [
            item.item.cad_pec,
            item.item.qtd_cad0_75,
            item.item.qtd_cad1_5,
          ],
        },
      ]
      this.expandedItem.acompanhados.series = [
        {
          data: [
            Math.abs(item.item.cad_pec - item.item.qtd_cad_acomp),
            item.item.qtd_acomp1_0,
            item.item.qtd_acomp1_2,
            item.item.qtd_acomp1_3,
            item.item.qtd_acomp2_5,
          ],
        },
      ]
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {},

    openModal(item) {
      this.currentPage = 1
      this.modal.enabled = true
      this.modal.title = item.x
      let dadosTabela = this.dadosDashboard.find((el) => {
        return el.classificacao == item.x
      })
      if (dadosTabela != undefined) {
        this.modal.table.data = JSON.parse(dadosTabela.micro_areas).map(
          (el) => {
            let dadosVinculoAcompanhamento = [
              { value: Number(el.escore_pec_cad), label: 'Vínculo' },
              {
                value: Number(el.escore_pec_acomp),
                label: 'Acompanhamento',
              },
            ]
            return {
              ...el,
              dados_vinculo_acompanhamento: dadosVinculoAcompanhamento,
            }
          }
        )
      }
    },
  },
}
</script>

<style lang="scss">
#dashboard-microareas {
  margin: 40px 0;
  h2 {
    font-size: 22px;
  }
}
</style>

<style>
#dashboard-microareas-modal .tag-indicador {
  background: #d6d2d2;
  color: #000;
  padding: 5px 10px;
  border-radius: 32px;
  font-size: 13px;
  margin-left: 5px;
  font-weight: 700;
}
</style>
